import React from "react";
import { Alert } from "../../Error/Alert";
import { ModalDivX } from "../../ModalDivX";
import { ModalLoader } from "../../ModalLoader";
import Modal from "react-modal";
import theme from "../../../Styles/theme";
import { IImovelFocus } from "../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import { IAvaliacao } from "../../../Hooks/avaliado";

import { Container, OkayButton, Title } from "./styles";
import { usePrefeitura } from "../../../Hooks/usePrefeitura";
import { useFuncionarioPrefeitura } from "../../../Hooks/funcionarioPrefeitura";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  imovel: IImovelFocus;
  avaliado: IAvaliacao;
}
export function ConfirmarAvaliacaoModal({
  open,
  onClose,
  imovel,
  avaliado,
}: Props) {
  const { prefeituraIsLogged } = usePrefeitura();
  const { funcionarioPrefeituraIsLogged } = useFuncionarioPrefeitura();

  function ConfirmarAvaliacao() {
    return (
      <>
        {avaliado ? (
          <Title>
            O imovél foi reavaliado, para gerar a guia de pagamento confirme a
            avaliação!
          </Title>
        ) : (
          <Title>
            O imovél foi avaliado, para gerar a guia de pagamento confirme a
            avaliação!
          </Title>
        )}
      </>
    );
  }

  function NotificaReavaliacaoModal() {
    return <Title>Este imóvel foi enviado para uma reavaliação!</Title>;
  }

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <ModalDivX execute={onClose} />
      <Container>
        {(prefeituraIsLogged || funcionarioPrefeituraIsLogged) 
          ? NotificaReavaliacaoModal()
          : ConfirmarAvaliacao()}
        <OkayButton onClick={onClose}>Ok</OkayButton>
      </Container>
    </Modal>
  );
}
